module.exports = __webpack_public_path__ + "static/media/drop.cda24e90.wav";


//////////////////
// WEBPACK FOOTER
// ./src/sound/drop.wav
// module id = 58
// module chunks = 0